<template>
  <div class="flex-1 overflow-auto p-4 campaigns-index-root">
    <woot-button
      color-scheme="success"
      class-names="button--fixed-top"
      icon="add-circle"
      @click="openAddPopup"
    >
      {{ buttonText }}
    </woot-button>
    <campaign />
    <woot-modal
      
      :show.sync="showAddPopup"
      
      :on-close="hideAddPopup"
      content-class="campaign-add-modal"
    
      :class="{ 'smart-campaign-modal': isSmartAiEmailType }"
    >
      <add-smart-ai-email-campaign
        v-if="isSmartAiEmailType"
        @on-close="hideAddPopup"
        @campaign-created="onCampaignCreated"
      />
      <add-campaign v-else @on-close="hideAddPopup" />
    </woot-modal>
  </div>
</template>

<script>
import campaignMixin from 'shared/mixins/campaignMixin';
import Campaign from './Campaign.vue';
import AddCampaign from './AddCampaign';
import AddSmartAiEmailCampaign from './AddSmartAiEmailCampaign';

export default {
  components: {
    Campaign,
    AddCampaign,
    AddSmartAiEmailCampaign,
  },
  mixins: [campaignMixin],
  data() {
    return { showAddPopup: false };
  },
  computed: {
    buttonText() {
      if (this.isOngoingType) {
        return this.$t('CAMPAIGN.HEADER_BTN_TXT.ONGOING');
      }
      if (this.isWhatsappType) {
        return this.$t('CAMPAIGN.HEADER_BTN_TXT.WHATSAPP');
      }
      if (this.isSmartAiEmailType) {
        return this.$t('CAMPAIGN.HEADER_BTN_TXT.SMART_AI_EMAIL');
      }
      if (this.isEmailCampaignType) {
        return this.$t('CAMPAIGN.HEADER_BTN_TXT.EMAIL');
      }
      return this.$t('CAMPAIGN.HEADER_BTN_TXT.ONE_OFF');
    },
  },
  methods: {
    openAddPopup() {
      this.showAddPopup = true;
    },
    hideAddPopup() {
      this.showAddPopup = false;
    },
    onCampaignCreated() {
      this.$store.dispatch('campaigns/getPaginated', {
        campaignType: this.campaignType,
        page: 1,
        perPage: 20,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/* Allow this to be the scroll container so child sticky pagination works */
.campaigns-index-root {
  min-height: 0;
  width: calc(100vw - 3.5rem);
}

::v-deep .smart-campaign-modal {
  .modal-container {
    border-radius: 12px;
    overflow: visible;
    position: relative;
    z-index: 1;
  }
  
  .modal--close {
    display: none;
  }

  /* Fix date picker to stay within modal bounds */
  .mx-datepicker-popup {
    z-index: 100 !important;
    position: absolute !important;
  }

  /* Create stacking context for modal */
  .modal-mask {
    z-index: 999;
  }
}
</style>
